var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceYourWatch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5413",
  transform: "translate(11728 3847)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#f1f1f1",
  "data-name": "Ellipse 737",
  transform: "translate(-11728 -3847)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1926"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0e2240",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M-11674.806-3822.552a20.736 20.736 0 0 1-23.259 31.417",
  "data-name": "Path 3683"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1925"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M-11690.526-3800.214h-3.108a.52.52 0 0 1-.518-.518v-2.224a8.2 8.2 0 0 1-2.143-.916l-1.568 1.57a.524.524 0 0 1-.733 0l-2.2-2.2a.52.52 0 0 1 0-.734l1.606-1.607a8.2 8.2 0 0 1-.856-2.129h-2.262a.52.52 0 0 1-.518-.517v-3.109a.52.52 0 0 1 .518-.517h2.3a8.3 8.3 0 0 1 .89-2.094l-1.617-1.617a.52.52 0 0 1 0-.734l2.2-2.2a.5.5 0 0 1 .365-.152.52.52 0 0 1 .367.152l1.632 1.635a8.2 8.2 0 0 1 2.1-.867v-2.279a.52.52 0 0 1 .52-.518h3.109a.52.52 0 0 1 .516.518v2.282a8.1 8.1 0 0 1 2.124.88l1.589-1.589a.5.5 0 0 1 .365-.149.52.52 0 0 1 .366.149l2.2 2.2a.52.52 0 0 1 0 .734l-1.58 1.575a8.2 8.2 0 0 1 .9 2.155h2.2a.52.52 0 0 1 .52.518v3.109a.52.52 0 0 1-.52.518h-2.2a8.3 8.3 0 0 1-.911 2.174l1.536 1.537a.52.52 0 0 1 0 .734l-2.2 2.2a.52.52 0 0 1-.734 0l-1.555-1.553a8.2 8.2 0 0 1-2.182.886v2.179a.52.52 0 0 1-.518.518m-1.47-14.345a3.6 3.6 0 1 0 3.6 3.6 3.6 3.6 0 0 0-3.6-3.6",
  "data-name": "Exclusion 1"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0e2240",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m-11679.525-3826.978 1.878 6.387 4.592-4.82Z",
  "data-name": "Path 3685"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0e2240",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M-11709.197-3799.449a20.736 20.736 0 0 1 23.259-31.417",
  "data-name": "Path 3686"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0e2240",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m-11704.423-3794.972-1.909-6.491-4.666 4.9Z",
  "data-name": "Path 3687"
})))));
export { SvgServiceYourWatch as ReactComponent };
export default "/_next/static/images/serviceYourWatch.svg";